import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ko from './ko.json';
import en from './en.json';

const savedLang = (() => {
  try {
    const v = localStorage.getItem('ourhertz_language');
    return v ? JSON.parse(v) : null;
  } catch {
    return null;
  }
})();

const browserLang = navigator.language.startsWith('ko') ? 'ko' : 'en';

i18n.use(initReactI18next).init({
  resources: {
    ko: { translation: ko },
    en: { translation: en },
  },
  lng: savedLang ?? browserLang,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
